import axios, { AxiosResponse } from "axios"
import { IAuthResponse } from "./types"
import { API_URL } from "../base"

export const login = (login: string, password: string): Promise<AxiosResponse<IAuthResponse>> => {
    return axios.post<IAuthResponse>(`/auth/login`, {
        login,
        password
    }, {
        baseURL: API_URL
    })
}

export const refresh = (token: string): Promise<AxiosResponse<IAuthResponse>> => {
    return axios.post<IAuthResponse>(`/auth/refresh`, {}, {
        headers: {
            Authorization: `Bearer ${token}`
        },
        baseURL: API_URL
    })
}
